const OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
};

/**
 * A date and time as the app shows them.
 *
 * A plain function rather than only a hook, because a grid's export formatter cannot call a hook —
 * and a column whose cell and whose exported value are formatted by two different pieces of code
 * ends up showing two different things.
 *
 * @param date - The moment, or nothing.
 * @param language - The language the app is running in.
 * @param missing - What to show when there is no date.
 */
export function formatDateTime(
  date: Date | string | undefined,
  language: string,
  missing = "---",
): string {
  if (!date || date === missing) {
    return missing;
  }

  const value = typeof date === "string" ? new Date(date) : date;
  return Number.isFinite(value.getTime()) ? value.toLocaleString(language, OPTIONS) : missing;
}
